/* AI 시공사례 — /agents/portfolio/write : 시공사례 등록(템플릿 고르기) / /agents/portfolio/showcase/:projectId : 편집 화면
   시공사례2 프로토타입을 인디피아로 옮긴 것. 저장·공개·AI는 sv-portfolio /showcase API. */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ErrorState, Skeleton } from '@indipia/ui-core';
import { showcaseApi, errorMessage } from './api/showcaseApi';
import { Toast } from './components/Common';
import { Editor } from './components/Editor';
import { Home } from './components/Home';
import { loadShowcaseFonts } from './model/constants';
import { pageId } from './model/types';
import { ed, loadProject, startNewCase, toast, useEd } from './store/editor';

const HOME = '/agents/portfolio';
const caseUrl = (id: number) => `${HOME}/showcase/${id}`;

export function ShowcasePage() {
  const e = useEd();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const id = projectId ? Number(projectId) : null;

  useEffect(() => { loadShowcaseFonts(); }, []);

  // 주소의 시공사례 열기 (이미 열려 있으면 그대로 — 템플릿으로 만드는 중이면 AI가 계속 쓴다)
  useEffect(() => {
    setError(null);
    if (!id) { ed.screen = 'home'; ed.bump(); return; }
    if (ed.projectId === id && ed.pages.length) { ed.screen = 'editor'; ed.bump(); return; }
    let alive = true;
    showcaseApi.get(id).then((c) => alive && loadProject(c)).catch((err) => alive && setError(errorMessage(err)));
    return () => { alive = false; };
  }, [id]);

  // 템플릿으로 새로 만들면(스토어가 새 번호를 받으면) 그 시공사례 주소로
  useEffect(() => {
    if (e.screen === 'editor' && e.projectId && e.projectId !== id) navigate(caseUrl(e.projectId), { replace: !id });
  }, [e.screen, e.projectId, id, navigate]);

  const blank = async () => {
    try {
      await startNewCase({ pages: [{ id: pageId(), bg: '#FFFFFF' /* dq-ignore: 문서 페이지 기본 배경 */, elements: [] }], title: '제목 없는 시공사례', templateId: 'basic', siteId: null, bundle: false });
      ed.chat.push({ role: 'system', text: '빈 페이지예요. 왼쪽 사진 탭에서 인디포토 사진을 넣고, 오른쪽 AI에게 하고 싶은 걸 말해 보세요.' });
      ed.bump();
    } catch (err) {
      toast('시공사례를 만들지 못했어요 — ' + errorMessage(err));
    }
  };

  let body;
  if (!id) body = <Home onBlank={blank} />;
  else if (error) body = <ErrorState className="h-full p-page" title="시공사례를 열지 못했어요" description={error} retryLabel="나의 시공사례로" onRetry={() => navigate(HOME)} />;
  else if (e.screen !== 'editor' || e.projectId !== id) body = <div className="h-full p-page" aria-busy="true" aria-label="시공사례를 여는 중"><Skeleton variant="block" height="100%" /></div>;
  else body = <Editor onHome={() => navigate(HOME)} />;
  return (
    <div data-showcase className="h-full text-text">
      {body}
      <Toast />
    </div>
  );
}
